//Core
import React from "react"

//styles
import style from "./style.module.scss"

const Banking = () => {
  return (
    <div className={style.BankingWrapper}>
      <div className={style.title}>До Інтернет-банкінгу</div>
      <a href="https://tas2u.tascombank.ua/">
        <div className={style.tas2u}>
          TAS2U <span>⎘</span>
        </div>
      </a>
    </div>
  )
}

export default Banking
